import {VivoRootModel} from "@utils/Models";
import {AccessRule} from "./accessRule";

/**
 * Customer Management module access (menu entry and the customer list/edit routes).
 *
 * The decision is made by the backend (`CurrentUserProfile.CanAccessCustomerManagement`, computed by the permission
 * provider for the effective lab/division), so this module contains no lab list and no role/segment policy.
 * Anything but an explicit `true` - missing root model, missing field, null, false, any other value - is denied.
 * It is module access only: per-customer read-only/edit/save checks stay with the API.
 * Contract: Vivo.Portal `ai_context/notes/customer-management-access-context-contract.md`.
 */
export const canAccessCustomerManagement: AccessRule = (context) =>
    context.rootModel?.CurrentUserProfile?.CanAccessCustomerManagement === true;

/**
 * Returns a copy of the root model whose Customer Management capability is explicitly denied.
 * Used for root models that are not authoritative for the identity that is about to be active
 * (token-issuing responses are built under the previous request context) until VerifyUser has confirmed it.
 */
export function withCustomerManagementDenied(model: VivoRootModel): VivoRootModel {
    return {
        ...model,
        CurrentUserProfile: {...model.CurrentUserProfile, CanAccessCustomerManagement: false},
    };
}
